import React, { useEffect, useMemo, useState } from "react";
import { GrAscend, GrDescend } from "react-icons/gr";
import { PiMagnifyingGlass } from "react-icons/pi";
import { TbReload } from "react-icons/tb";
import SidebarModelsLoading from "../Loaders/SidebarModelsLoading";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const PoolerSidebar = ({
    show,
    handleClose,
}) => {
    const { t } = useLanguage()


    return (
        <div className={`sidebar_right_cont ${show ? "sidebar_right_cont_show" : ""}`}>
            <div className="sidebar_right_close" onClick={handleClose}></div>
            <div className="sidebar_right_main">
                <div className="sidebar_right_main_header">
                    <p>{t.omnit0.kicker}</p>
                    <button onClick={handleClose}><i className="fa-solid fa-x"></i></button>
                </div>


                <div className="sidebar_right_main_body">
                    <p className="sidebar_right_main_body_title">Omni-t0</p>
                    <p className="sidebar_right_main_body_desc" dangerouslySetInnerHTML={{__html: t.omnit0.description}}></p>
                </div>
            </div>
        </div>
    );
}

export default PoolerSidebar;